import React from 'react';
import NoteIdentificationPage from './pages/StaffNoteIdentification/NoteIdentificationPage';

const App: React.FC = () => {
  return (
    <div className="App">
      <NoteIdentificationPage />
    </div>
  );
};

export default App;

